import { Button, Container, Flex, ScrollArea, Select, Spinner, Table, Text, TextField } from "@radix-ui/themes";
import useFetch from "../../core/hooks/useFetch";
import { ReactNode, useEffect, useMemo, useRef, useState } from "react";
import {IProgrammMinfin} from '../../core/types/services-types/programms-minfin'
import ProgrammMinfinService from '../../core/services/ProgrammMinfinService'
import { toast, ToastContainer } from "react-toastify";
import TransactionService from "../../core/services/TransactionService";
import { GetAllTransactionsFormRequest, ITransaction, SendMoneysFromCurrentMinfinToAccountMinfinRequest } from "../../core/types/services-types/transaction-types";
import FilterTransactionsForm from "../../components/controls/forms/filter-transactions-form";
import { ArrowTopRightIcon, MixerVerticalIcon, PinLeftIcon } from "@radix-ui/react-icons";
import { form_to_json } from "../../utils";
import AppTable from "../../components/controls/tables/AppTable";
import Pagination from "../../components/common/renders/pagination-render";
import moment from "moment";
import { Link } from "react-router";
import BaseModal from "../../components/controls/modals/BaseModal";
export default function ProgrammsMinfin() {
      const transactionsHeadersTableFormat = useMemo<(string | ReactNode)[]>(() => {
        return [
            "ID",
            "Внешний ID",
            "Отправитель",
            "Тип",
            "Валюта",
            "Комиссия",
            "Количество",
            "Куда",
            "Статус",
            "Сообщение",
            "Тип отправителя",
            "Разделенный платеж",
            "ID Состава Субъекта права",
            "Создано",
            "Обновлено",
            "Действия"
        ]}, [])
    const [programmsMinfin, setProgrammsMinfin] = useState<IProgrammMinfin[]>([])
    const [transactions, setTransactions] = useState<ITransaction[]>([])
    const [totalCount, setTotalCount] = useState<number>(0)
    const [limit, setLimit] = useState(100)
    const [page, setPage] = useState(0)
    const [openModalSendMoneys, setOpenModalSendMoneys] = useState<boolean>(false)
    const refFormFilters = useRef<HTMLFormElement | null>(null)
    const refFormSendMoneys = useRef<HTMLFormElement | null>(null)
    const [fetchMinfinProgramms, isLoadingMinfinProgramms, errorMinfinProgramms, errorsMinfinProgramms] = useFetch(async () => {
        const data = await ProgrammMinfinService.GetAll()
        setProgrammsMinfin(data)
    })

    const [fetchAllTransactionsMinfin, isLoadingFetchAllTransactionsMinfin, errorFetchAllTransactionsminfin, errorsAllTransactionsMinfin] = useFetch(async (form: FormData) => {
        const jsonForm = form_to_json<GetAllTransactionsFormRequest>(form)
        console.log(jsonForm)
        const data = await TransactionService.GetAllMinfin(jsonForm.search, jsonForm.minAmount, jsonForm.maxAmount, jsonForm.currency, jsonForm.dateSort, limit, page)
        setTransactions(data.data)
        setTotalCount(data.count)
    })

    const [fetchSendMoneysToAccountMinfin, isLoadingSendMoneysToAccountMinfin, errorSendMoneysToAccountMinfin, errorsSendMoneysToAccountMinfin] = useFetch(async () => {
        const data = await TransactionService.SendMoneysFromMinfinToMinfinAccount()
        toast.success(data.message)
    })

    const [fetchSendMoneysCurrentToAccountMinfin, isLoadingSendMoneysCurrentToAccountMinfin, errorSendMoneysCurrentToAccountMinfin, errorsSendMoneysCurrentToAccountMinfn] = useFetch(async (form: FormData) => {
        const jsonForm = form_to_json<SendMoneysFromCurrentMinfinToAccountMinfinRequest>(form)
        const data = await TransactionService.SendMoneysFromMinfinCurrentToMinfinAccount(jsonForm)
        setProgrammsMinfin(data.data)
        toast.success(data.message)
    })



     const onSubmitFilters = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        if (refFormFilters.current) {
            const form = new FormData(refFormFilters.current)
            await fetchAllTransactionsMinfin(form)
        }
    }

    const onSubmitSendMoneys = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        setOpenModalSendMoneys(false)
        if(refFormSendMoneys.current) {
            const form = new FormData(refFormSendMoneys.current)
            await fetchSendMoneysCurrentToAccountMinfin(form)
        }
    }

    const changeActiveIndex = (page: number) => {
        setPage(page)
    }

    const renderModal = (
        <Container>
        <form ref={refFormSendMoneys} onSubmit={onSubmitSendMoneys}> 
        <Flex direction={'column'}> 
        <Text>
            Выберите Минфин
        </Text>
        <Select.Root defaultValue='null' name="id">
		<Select.Trigger />
		<Select.Content>
            <Select.Item value="null">Выберите Минфин</Select.Item>
            {programmsMinfin.map(item => {
                return (
                    <Select.Item value={item.id.toString()}>{item.name}</Select.Item>
                )
            })}
		</Select.Content>
	    </Select.Root>
        </Flex>
        <Flex direction={'column'} mt={'3'} mb={'5'}> 
        <Text>
            Введите количество
        </Text>
        <TextField.Root type="number" placeholder="10000" name="count">
            
        </TextField.Root>
        </Flex>
        <Button color="green" variant="solid">Подтвердить</Button>
        </form>
        </Container>
        
    )

    const transactionsTableFormat = useMemo(() => {
    return transactions.map(item => {
        const filterItem = {
            ...item,
            user_id: item.sender.login,
            sender: '',
            receiver: '',
            to: item.receiver?.login ?? ''
        }

        const actions = [
            "Действия",
            <Flex gap={'3'} key={item.id}>
                <Link to={`/transaction/${item.id}`}>
                    <Button variant='surface'>
                        <ArrowTopRightIcon />
                    </Button>
                </Link>
            </Flex>
        ]

        return Object.entries(filterItem).concat([actions])
    })
}, [transactions])

      const renderOption = (key: string, value: any) => {
            if(key === 'status') {
                if(value === 'created') {
                    return ( 
                    <Table.Cell>
                       <Text color='orange'> Создана </Text>
                        </Table.Cell>
                    )
                }
                if(value === 'success') {
                    return (
                        <Table.Cell>
                       <Text color="grass"> Подтверждена </Text>
                        </Table.Cell>
                    
                    )
                }
            }
            if(key === 'splitted') {
                if(value === true) {
                    return (
                       <Table.Cell>
                       <Text color="grass"> Да </Text>
                        </Table.Cell>
                    )
                }
                else {
                    return (
                        <Table.Cell>
                       <Text color="grass"> Нет </Text>
                        </Table.Cell>
                    )
                }
            }
            if(key === 'createdAt' || key === 'updatedAt') {
               return ( 
                <Table.Cell>
               { moment(value).format("DD.MM.YYYY HH:mm")}
                </Table.Cell>
               )
            }
            if(key === 'message') {
                if(value) {
                return (
                     <Table.Cell>
               {value.substring(0, 40)}...
                </Table.Cell>
                )
            }
            }
            return <Table.Cell>{value}</Table.Cell>
        }


    useEffect(() => {
        fetchMinfinProgramms()
    }, [])

    useEffect(() => {
        if(refFormFilters.current) {
        fetchAllTransactionsMinfin(new FormData(refFormFilters.current))
        }
    }, [limit, page])
    useEffect(() => {
        if (errorMinfinProgramms) toast.error(errorMinfinProgramms)
    }, [errorMinfinProgramms])
    useEffect(() => {
        if(errorSendMoneysToAccountMinfin) toast.error(errorSendMoneysToAccountMinfin) 
    }, [errorSendMoneysToAccountMinfin])
    useEffect(() => {
        if(errorSendMoneysCurrentToAccountMinfin) toast.error(errorSendMoneysCurrentToAccountMinfin)
    }, [errorSendMoneysCurrentToAccountMinfin])
    return (
        <Container className="md:p-5 pt-5 bg-zinc-100 min-h-[100vh]">
             <ToastContainer
              position="top-center"
              />
            <Container className="bg-zinc-50 rounded-lg shadow-lg p-10 mb-5"> 
                <Text weight={'bold'} size={'6'}>Программы Министерства Финансов СССР</Text>
            </Container>
             <Container className="bg-zinc-50 rounded-lg shadow-lg p-10 mb-20"> 
                {isLoadingMinfinProgramms ? <Spinner /> : programmsMinfin.map(item => {
                    return (
                        <Flex key={item.id} align={'center'} wrap={'wrap'} gap={'5'} className="mb-5 border-gray border-b-2">
                            <Text weight={'bold'} size={'3'}>
                                {item.name}
                            </Text>
                            <Text weight={'bold'} size={'3'} color="grass">
                                {item.balance}
                            </Text>
                            
                        </Flex>
                    )
                })}
                  <BaseModal 
                              showButton={<Button disabled={isLoadingMinfinProgramms} variant='outline' loading={isLoadingSendMoneysCurrentToAccountMinfin} onClick={() => setOpenModalSendMoneys(true)}>
                                  <PinLeftIcon />
                                  Распределить в Министерство Финансов СССР
                              </Button>}
                              title="Перевод денег с Министерства на аккаунт Минфин"
                              description={renderModal}
                              cancelButton={<Button color="red" variant='solid'>Отмена</Button>}
                              successButton={<></>}
                              open={openModalSendMoneys}
                              />
            </Container>
            <Container className="bg-zinc-50 rounded-lg shadow-lg p-10 mb-5"> 
                <Text weight={'bold'} size={'6'}>Транзакции</Text>
                <Flex className="filters">
                    <form ref={refFormFilters} onSubmit={onSubmitFilters}>
                        <FilterTransactionsForm 
                        search
                        min
                        max
                        currency
                        sortDate

                        />
                        <Button>
                            <MixerVerticalIcon />
                            Применить фильтры
                        </Button>
                    </form>
                </Flex>
            </Container>
            <Container className="bg-zinc-50 rounded-lg shadow-lg p-10 mb-5"> 
           <ScrollArea type="always" scrollbars="both" style={{ height: 650 }} >
            {
            isLoadingFetchAllTransactionsMinfin ? 
            "Загрузка..."
                :
                <AppTable
                headers={transactionsHeadersTableFormat} 
                data={transactionsTableFormat}
                renderOption={renderOption}
                />
            }
           
           </ScrollArea>
           <Container className="p-2"> 
           <Pagination
           total={totalCount} 
           count={limit} 
           activeIndex={page}
           onChangeIndex={changeActiveIndex}
           />
           </Container>
            </Container>
        </Container>
    )
}